export const REQUEST_SUPERADMINDASHBOARD_DATA = 'REQUEST_SUPERADMINDASHBOARD_DATA';
export const SUPERADMINDASHBOARD_DATA_RECEIVED = 'SUPERADMINDASHBOARD_DATA_RECIEVED';